<template>
  <el-select :value="valueTitle" :clearable="clearable" popper-class="selectTree" :size="size" @clear="clearHandle">
    <el-option :value="valueTitle" :label="valueTitle">
      <el-tree
        id="tree-option"
        ref="selectTree"
        :accordion="accordion"
        :data="options"
        :props="props"
        highlight-current
        :default-expand-all="false"
        node-key="id"
        :default-expanded-keys="defaultExpandedKey"
        @node-click="handleNodeClick">
      </el-tree>
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: "SelectTree",
  props: {
    /* 配置项 */
    props: {
      type: Object,
      default: () => {
        return {
          value: 'id', // ID字段名
          label: 'cnName', // 显示名称
          children: 'list' // 子级字段名
        };
      }
    },
    /* 选项列表数据(树形结构的对象数组) */
    options: {
      type: Array,
      default: () => { return []; }
    },
    /* 初始值 */
    value: {
      type: String,
      default: () => { return ""; }
    },
    /* 可清空选项 */
    clearable: {
      type: Boolean,
      default: () => { return true; }
    },
    /* 自动收起 */
    accordion: {
      type: Boolean,
      default: () => { return false; }
    },
    /* 初始值 */
    size: {
      type: String,
      default: () => { return ""; }
    }
  },
  data() {
    return {
      valueId: this.value, // 初始值
      valueTitle: '',
      defaultExpandedKey: []
    };
  },
  watch: {
    value() {
      this.valueId = this.value;
      this.initHandle();
    }
  },
  mounted() {
    console.log(this.valueId, 'this.valueId');
    console.log(this.options, 'this.options');
    this.initHandle();
  },
  methods: {
    // 初始化值
    initHandle() {
      const that = this;
      setTimeout(() => {
        if (that.valueId) {
          that.valueTitle = that.$refs.selectTree.getNode(that.valueId).data[that.props.label]; // 初始化显示
          that.$refs.selectTree.setCurrentKey(that.valueId); // 设置默认选中
          that.defaultExpandedKey = [that.valueId]; // 设置默认展开
        } else {
          that.valueTitle = '', // 初始化显示
          that.$refs.selectTree.setCurrentKey(null); // 设置默认选中
          that.defaultExpandedKey = [];
        }
      }, 200);
      that.$nextTick(() => {
        const scrollWrap = document.querySelectorAll('.selectTree .el-scrollbar .el-select-dropdown__wrap')[0];
        const scrollBar = document.querySelectorAll('.selectTree .el-scrollbar .el-scrollbar__bar');
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;';
        scrollBar.forEach(ele => ele.style.width = 0);
      });
    },
    // 切换选项
    handleNodeClick(node) {
      this.valueTitle = node[this.props.label];
      this.valueId = node[this.props.value];
      this.$emit('getValue', { valueId: this.valueId, valueTitle: this.valueTitle });
      this.defaultExpandedKey = [];
    },
    // 清除选中
    clearHandle() {
      this.valueTitle = '';
      this.valueId = '';
      this.defaultExpandedKey = [];
      this.clearSelected();
      this.$emit('getValue', { valueId: this.valueId, valueTitle: this.valueTitle });
    },
    // 清空选中样式
    clearSelected() {
      const allNode = document.querySelectorAll('#tree-option .el-tree-node');
      allNode.forEach((element) => element.classList.remove('is-current'));
    }
  }
};
</script>
<style lang="scss">
.selectTree .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.selectTree .el-select-dropdown__item.selected{
  font-weight: normal;
}
.selectTree  ul li >>>.el-tree .el-tree-node__content{
  height:auto;
  padding: 0 20px;
}
.selectTree .el-tree-node__label{
  font-weight: normal;
}
.selectTree .el-tree-node__content{
  height:auto!important;
  display: block;
  white-space: pre-wrap;
  max-width: 464px;
  margin: 0 !important;;
}
.selectTree  .el-tree >>>.is-current .el-tree-node__label{
  color: var(--theme-color);
  font-weight: 700;
}
.selectTree .el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{
  color:#606266;
  font-weight: normal;
}
.selectTree .el-scrollbar__wrap{
  margin: 0px !important;
}
</style>
